(function(angular){
	'use strict';

	angular
		.module('contactModule')
		.factory('contactFactory', [
			'mixpanelFactory',
			'urlFactory',
			ContactFactoryFunction
		]);

	function ContactFactoryFunction(
		mixpanelFactory,
		urlFactory
	) {
		var factory = {
			sendMessage: sendMessage
		};

		return factory;

		function sendMessage(params) {
			var firstName, lastName;
			var names = params.name.split(' ');
			firstName = names.shift();

			if(names.length === 1) {
				lastName = names[0];
			} else if(names.length > 1) {
				lastName = names.join(' ');
			} else {
				lastName = '';
			}

			var payload = {
				firstName: firstName,
				lastName: lastName,
				email: params.email,
				message: params.message,
				captchaAnswer: params.captchaAnswer,
				mixpanelId: mixpanelFactory.getDistinctId()
			};

			return urlFactory.apiPostPromise('/api/contact', payload)
				.catch(function(response) {
					return urlFactory.handleFailedRequest(response);
				});
		}
	}
})(window.angular);